<template>
  <product-single :product="product" />
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import ProductSingle from '../../components/Produits/Produit_PleinePage';

  export default {
    name: 'product',
    components: { ProductSingle },
    beforeMount() {
      this.getProducts();
    },
    computed: {
      ...mapGetters('products', {
        getProduct: 'getProduct'
      }),
      product() {
        return this.getProduct(this.$route.params.id);
      }
    },
    methods: {
      ...mapActions('products', {
        getProducts: 'getAll'
      })
    }
  };
</script>
